import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";
import RoutingIcon from "Components/Generic/Icons/RoutingIcon";

export const HeaderStepper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  paddingBottom: "16px",
  boxSizing: "border-box",
  gap: "8px 0px",
  "@media screen and (max-width: 860px)": {
    minWidth: "100%",
    padding: 16,
  },
}));

export const ProgressBar = styled("div")(() => ({
  alignSelf: "stretch",
  borderRadius: 8,
  overflow: "hidden",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gap: "0px 4px",
}));

export const StepContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "8px",
}));
export const StepLineContainer = styled("div")(() => ({
  alignSelf: "flex-end",
  position: "relative",
  height: 4,
  width: "110px",
}));

export const StepLineLabel = styled("span")(() => ({
  color: colors.gray800,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  position: "relative",
  left: "8px",
}));

type StepLineProps = {
  right?: string | number;
};
export const StepLine = styled("div")((_props: StepLineProps) => ({
  position: "absolute",
  height: "100%",
  width: "100%",
  top: 0,
  right: "5%",
  bottom: 0,
  left: "5%",
}));

export const StepLineChildFilled = styled(StepLine)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  opacity: "0.5",
}));

export const StepLineChild = styled(StepLine)(() => ({
  backgroundColor: colors.white,
  "@media screen and (max-width: 860px)": {
    backgroundColor: colors.gray200,
  },
}));

export const StepLineInProgress = styled(StepLine)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));

export const ContainerInfoStatus = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  "@media screen and (max-width: 860px)": {
    flexDirection: "column",
  },
}));

export const ContainerInfoButton = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  alignItems: "center",
}));

export const ContainerInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  flex: "3",
  gap: "60px",
  "@media screen and (min-width: 790px)": {
    gap: "40px",
  },
}));

export const InfoText = styled("span")(() => ({
  fontSize: "14px",
  letterSpacing: "0.1px",
  lineHeight: "20px",
  fontWeight: 600,
  fontFamily: "Manrope",
  color: "#667085",
}));

export const ActualStatus = styled(InfoText)(() => ({
  color: colors.gray800,
  fontWeight: 700,
  marginLeft: "4px",
  "@media screen and (max-width: 860px)": {
    fontSize: 16,
  },
}));

export const NextStep = styled(InfoText)(() => ({
  color: colors.gray800,
  fontWeight: 700,
  marginLeft: "4px",
  "@media screen and (max-width: 860px)": {
    fontSize: 16,
  },
}));

export const ButtonAllSteps = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  cursor: "pointer",

  "& span": {
    color: theme.palette.primary.main,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    marginRight: "4px !important",
    position: "relative",
    top: "2px",
  },

  "& > svg": {
    "& > path": {
      fill: theme.palette.primary.main,
    },
  },
}));

export const OpenMilestonesButtonWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  flex: 1,
  marginBottom: "8px",
}));

export const MoveProgressLabel = styled("div")(() => ({
  color: colors.gray900,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const ShowMore = styled("div")(() => ({
  cursor: "pointer",
  display: "flex",
}));

export const StyledRoutingIcon = styled(RoutingIcon)(({ theme }) => ({
  "& > svg": {
    "& > path": {
      fill: theme.palette.primary.main,
    },
  },
}));

const styles = makeStyles(() => ({
  milestonesLoading: {
    minWidth: "450px",
    "&.MuiSkeleton-text": {
      marginBottom: "16px",
    },
  },
}));

export default styles;
